import { j as u } from "./jsx-runtime-3tyXYecC.mjs";
import * as f from "react";
import { forwardRef as j } from "react";
import { T as Z } from "./typography-Bj_iezxf.mjs";
import { m as Pe } from "./tss-DN0acMKN.mjs";
import { M as R, d as S } from "./constants-CnFYFetN.mjs";
import { g as G, a as W, b as O, c as q, d as X, e as $e, u as Ce } from "./useButton-BpXsRUgx.mjs";
import { T as Re } from "./Typography-DfkimCSn.mjs";
import { s as _ } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { _ as D, a as p, u as le } from "./objectWithoutPropertiesLoose-Cg0fb85x.mjs";
import { _ as ie } from "./composeRefs-YONvD-rx.mjs";
import { o as Se } from "./ownerDocument-B2qVP_sX.mjs";
let ne = 0;
function we(e) {
  const [t, o] = f.useState(e), n = t;
  return f.useEffect(() => {
    t == null && (ne += 1, o(`mui-${ne}`));
  }, [t]), n;
}
const se = f.useId;
function Ue(e) {
  return se !== void 0 ? se() : we(e);
}
function je({
  controlled: e,
  default: t,
  name: o,
  state: n = "value"
}) {
  const {
    current: s
  } = f.useRef(e !== void 0), [l, y] = f.useState(t), b = s ? e : l, i = f.useCallback((a) => {
    s || y(a);
  }, []);
  return [b, i];
}
function _e(e) {
  return W("TabPanelUnstyled", e);
}
G("TabPanelUnstyled", ["root", "hidden"]);
function De(e) {
  return W("TabsUnstyled", e);
}
G("TabsUnstyled", ["root", "horizontal", "vertical"]);
const Ie = (e) => {
  const {
    value: t,
    defaultValue: o,
    onChange: n,
    orientation: s,
    direction: l,
    selectionFollowsFocus: y
  } = e, [b, i] = je({
    controlled: t,
    default: o,
    name: "Tabs",
    state: "value"
  }), a = Ue(), m = f.useCallback((h, x) => {
    i(x), n && n(h, x);
  }, [n, i]), v = () => ({}), T = f.useMemo(() => ({
    idPrefix: a,
    value: b,
    onSelected: m,
    orientation: s,
    direction: l,
    selectionFollowsFocus: y
  }), [a, b, m, s, l, y]);
  return {
    getRootProps: v,
    tabsContextValue: T
  };
}, ce = /* @__PURE__ */ f.createContext(null);
function ee() {
  return f.useContext(ce);
}
function de(e, t) {
  const {
    idPrefix: o
  } = e;
  return o === null ? null : `${e.idPrefix}-P-${t}`;
}
function ue(e, t) {
  const {
    idPrefix: o
  } = e;
  return o === null ? null : `${e.idPrefix}-T-${t}`;
}
const Fe = ["children", "className", "value", "defaultValue", "orientation", "direction", "component", "components", "componentsProps", "onChange", "selectionFollowsFocus"], Ee = (e) => {
  const {
    orientation: t
  } = e;
  return X({
    root: ["root", t]
  }, De, {});
}, Le = /* @__PURE__ */ f.forwardRef((e, t) => {
  var o, n;
  const {
    children: s,
    className: l,
    orientation: y = "horizontal",
    direction: b = "ltr",
    component: i,
    components: a = {},
    componentsProps: m = {}
  } = e, v = D(e, Fe), {
    tabsContextValue: T,
    getRootProps: h
  } = Ie(e), x = p({}, e, {
    orientation: y,
    direction: b
  }), $ = Ee(x), r = (o = i ?? a.Root) != null ? o : "div", d = O(r, p({}, v, m.root), x);
  return /* @__PURE__ */ u.jsx(r, p({}, h(), d, {
    ref: t,
    className: q($.root, (n = m.root) == null ? void 0 : n.className, l),
    children: /* @__PURE__ */ u.jsx(ce.Provider, {
      value: T,
      children: s
    })
  }));
}), Ne = (e) => {
  const {
    value: t
  } = e, o = ee();
  if (o === null)
    throw new Error("No TabContext provided");
  const n = t !== o.value, s = de(o, t), l = ue(o, t);
  return {
    hidden: n,
    getRootProps: () => ({
      "aria-labelledby": l,
      hidden: n,
      id: s
    })
  };
}, ke = ["children", "className", "value", "components", "componentsProps", "component"], He = (e) => {
  const {
    hidden: t
  } = e;
  return X({
    root: ["root", t && "hidden"]
  }, _e, {});
}, Ae = /* @__PURE__ */ f.forwardRef(function(t, o) {
  var n, s;
  const {
    children: l,
    className: y,
    components: b = {},
    componentsProps: i = {},
    component: a
  } = t, m = D(t, ke), {
    hidden: v,
    getRootProps: T
  } = Ne(t), h = p({}, t, {
    hidden: v
  }), x = He(h), $ = (n = a ?? b.Root) != null ? n : "div", r = O($, p({}, m, i.root), h);
  return /* @__PURE__ */ u.jsx($, p({}, T(), {
    ref: o,
    role: "tabpanel"
  }, r, {
    className: q(x.root, (s = i.root) == null ? void 0 : s.className, y),
    children: !v && l
  }));
});
function Ve(e) {
  return W("TabsListUnstyled", e);
}
G("TabsListUnstyled", ["root", "horizontal", "vertical"]);
var c = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y = 60103, J = 60106, I = 60107, F = 60108, E = 60114, L = 60109, N = 60110, k = 60112, H = 60113, te = 60120, A = 60115, V = 60116, fe = 60121, pe = 60122, be = 60117, me = 60129, ye = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var g = Symbol.for;
  Y = g("react.element"), J = g("react.portal"), I = g("react.fragment"), F = g("react.strict_mode"), E = g("react.profiler"), L = g("react.provider"), N = g("react.context"), k = g("react.forward_ref"), H = g("react.suspense"), te = g("react.suspense_list"), A = g("react.memo"), V = g("react.lazy"), fe = g("react.block"), pe = g("react.server.block"), be = g("react.fundamental"), me = g("react.debug_trace_mode"), ye = g("react.legacy_hidden");
}
function w(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case Y:
        switch (e = e.type, e) {
          case I:
          case E:
          case F:
          case H:
          case te:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case N:
              case k:
              case V:
              case A:
              case L:
                return e;
              default:
                return t;
            }
        }
      case J:
        return t;
    }
  }
}
var ze = L, Me = Y, Be = k, Ke = I, Ge = V, We = A, Oe = J, qe = E, Xe = F, Ye = H;
c.ContextConsumer = N;
c.ContextProvider = ze;
c.Element = Me;
c.ForwardRef = Be;
c.Fragment = Ke;
c.Lazy = Ge;
c.Memo = We;
c.Portal = Oe;
c.Profiler = qe;
c.StrictMode = Xe;
c.Suspense = Ye;
c.isAsyncMode = function() {
  return !1;
};
c.isConcurrentMode = function() {
  return !1;
};
c.isContextConsumer = function(e) {
  return w(e) === N;
};
c.isContextProvider = function(e) {
  return w(e) === L;
};
c.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Y;
};
c.isForwardRef = function(e) {
  return w(e) === k;
};
c.isFragment = function(e) {
  return w(e) === I;
};
c.isLazy = function(e) {
  return w(e) === V;
};
c.isMemo = function(e) {
  return w(e) === A;
};
c.isPortal = function(e) {
  return w(e) === J;
};
c.isProfiler = function(e) {
  return w(e) === E;
};
c.isStrictMode = function(e) {
  return w(e) === F;
};
c.isSuspense = function(e) {
  return w(e) === H;
};
c.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === I || e === E || e === me || e === F || e === H || e === te || e === ye || typeof e == "object" && e !== null && (e.$$typeof === V || e.$$typeof === A || e.$$typeof === L || e.$$typeof === N || e.$$typeof === k || e.$$typeof === be || e.$$typeof === fe || e[0] === pe);
};
c.typeOf = w;
const re = (e, t) => e ? e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild : null, ae = (e, t) => e ? e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild : null, M = (e, t, o) => {
  let n = !1, s = o(e, t);
  for (; e && s; ) {
    if (s === e.firstChild) {
      if (n)
        return;
      n = !0;
    }
    const l = s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || l)
      s = o(e, s);
    else {
      s.focus();
      return;
    }
  }
}, ge = (e) => {
  const {
    "aria-label": t,
    "aria-labelledby": o,
    children: n,
    ref: s
  } = e, l = /* @__PURE__ */ f.createRef(), y = le(l, s), b = ee();
  if (b === null)
    throw new Error("No TabContext provided");
  const {
    value: i,
    orientation: a = "horizontal",
    direction: m = "ltr"
  } = b, v = m === "rtl", T = (r) => {
    const d = l.current, P = Se(d).activeElement;
    if ((P == null ? void 0 : P.getAttribute("role")) !== "tab")
      return;
    let C = a === "horizontal" ? "ArrowLeft" : "ArrowUp", z = a === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (a === "horizontal" && v && (C = "ArrowRight", z = "ArrowLeft"), r.key) {
      case C:
        r.preventDefault(), M(d, P, ae);
        break;
      case z:
        r.preventDefault(), M(d, P, re);
        break;
      case "Home":
        r.preventDefault(), M(d, null, re);
        break;
      case "End":
        r.preventDefault(), M(d, null, ae);
        break;
    }
  }, h = (r) => (d) => {
    var P;
    T(d), (P = r.onKeyDown) == null || P.call(r, d);
  }, x = (r) => {
    const d = $e(e), P = p({}, d, r), U = {
      onKeyDown: h(P)
    }, C = p({}, P, U);
    return p({
      "aria-label": t,
      "aria-labelledby": o,
      "aria-orientation": a === "vertical" ? "vertical" : null,
      role: "tablist",
      ref: y
    }, C);
  }, $ = f.useCallback(() => {
    const r = /* @__PURE__ */ new Map();
    let d = 0;
    return f.Children.map(n, (U) => {
      if (!/* @__PURE__ */ f.isValidElement(U))
        return null;
      const C = U.props.value === void 0 ? d : U.props.value;
      return r.set(C, d), d += 1, /* @__PURE__ */ f.cloneElement(U, p({
        value: C
      }, d === 1 && i === !1 && !U.props.tabIndex || i === C ? {
        tabIndex: 0
      } : {
        tabIndex: -1
      }));
    });
  }, [n, i]);
  return {
    isRtl: v,
    orientation: a,
    value: i,
    processChildren: $,
    getRootProps: x
  };
}, Je = ["className", "children", "component", "components", "componentsProps"], Qe = (e) => {
  const {
    orientation: t
  } = e;
  return X({
    root: ["root", t]
  }, Ve, {});
}, Ze = /* @__PURE__ */ f.forwardRef((e, t) => {
  var o, n;
  const {
    className: s,
    component: l,
    components: y = {},
    componentsProps: b = {}
  } = e, i = D(e, Je), {
    isRtl: a,
    orientation: m,
    getRootProps: v,
    processChildren: T
  } = ge(p({}, e, {
    ref: t
  })), h = p({}, e, {
    isRtl: a,
    orientation: m
  }), x = Qe(h), $ = (o = l ?? y.Root) != null ? o : "div", r = O($, p({}, i, b.root), h), d = T();
  return /* @__PURE__ */ u.jsx($, p({}, v(), r, {
    className: q(s, (n = b.root) == null ? void 0 : n.className, x.root),
    children: d
  }));
});
function et(e) {
  return W("TabUnstyled", e);
}
const B = G("TabUnstyled", ["root", "selected", "disabled"]), tt = ["getRootProps"], ot = (e) => {
  const {
    value: t,
    onChange: o,
    onClick: n,
    onFocus: s
  } = e, l = Ce(e), {
    getRootProps: y
  } = l, b = D(l, tt), i = ee();
  if (i === null)
    throw new Error("No TabContext provided");
  const a = t ?? 0, m = i.value === a, v = i.selectionFollowsFocus, T = {
    role: "tab",
    "aria-controls": de(i, a),
    id: ue(i, a),
    "aria-selected": m,
    disabled: b.disabled
  }, h = (r) => {
    v && !m && (o && o(r, a), i.onSelected(r, a)), s && s(r);
  }, x = (r) => {
    m || (o && o(r, a), i.onSelected(r, a)), n && n(r);
  };
  return p({
    getRootProps: (r) => {
      const d = y(p({
        onClick: x,
        onFocus: h
      }, r));
      return p({}, d, T);
    }
  }, b, {
    selected: m
  });
}, nt = ["action", "children", "value", "className", "disabled", "onChange", "onClick", "onFocus", "component", "components", "componentsProps"], st = (e) => {
  const {
    selected: t,
    disabled: o
  } = e;
  return X({
    root: ["root", t && "selected", o && "disabled"]
  }, et, {});
}, rt = /* @__PURE__ */ f.forwardRef(function(t, o) {
  var n, s;
  const {
    action: l,
    children: y,
    className: b,
    disabled: i = !1,
    component: a,
    components: m = {},
    componentsProps: v = {}
  } = t, T = D(t, nt), h = f.useRef(), x = le(h, o), {
    active: $,
    focusVisible: r,
    setFocusVisible: d,
    selected: P,
    getRootProps: U
  } = ot(p({}, t, {
    ref: x
  }));
  f.useImperativeHandle(l, () => ({
    focusVisible: () => {
      d(!0), h.current.focus();
    }
  }), [d]);
  const C = p({}, t, {
    active: $,
    focusVisible: r,
    disabled: i,
    selected: P
  }), z = st(C), oe = (n = a ?? m.Root) != null ? n : "button", Te = O(oe, p({}, T, v.root), C);
  return /* @__PURE__ */ u.jsx(oe, p({}, U(), Te, {
    className: q(z.root, (s = v.root) == null ? void 0 : s.className, b),
    ref: o,
    children: y
  }));
}), Q = "--side-tab-padding-x", K = "--side-tabs-layout-padding-y", at = j(function(t, o) {
  return /* @__PURE__ */ u.jsx(Z, { color: "gray.800", component: "span", fontWeight: "regular", ref: o, variant: "teenie", ...t });
}), lt = Pe()(({ mode: e, palette: t, typography: o }) => ({
  root: {
    color: e === R.Dye ? S.main : t.gray[800],
    [`.${B.disabled} &`]: {
      color: e === R.Dye ? S.lighter : t.gray[500]
    },
    [`.${B.selected} &`]: {
      color: e === R.Dye ? S.main : t.primary.main,
      fontWeight: o.fontWeightHeavy
    }
  }
})), it = j(function({ children: t, note: o, ...n }, s) {
  const { classes: l } = lt();
  return /* @__PURE__ */ u.jsxs(Re, { classes: l, component: "span", ...n, ref: s, children: [
    t,
    " ",
    o && /* @__PURE__ */ u.jsx(at, { children: o })
  ] });
}), ct = _(rt)(({ theme: e }) => ({
  background: "none",
  border: "none",
  borderRadius: "2px",
  display: "inline-block",
  outline: e.mode === R.Dye ? `1px solid ${S.main}` : void 0,
  overflow: "hidden",
  overflowWrap: "anywhere",
  padding: `${e.spacing(1)} var(${Q})`,
  textAlign: "left",
  textDecoration: "none",
  whiteSpace: "normal",
  width: "100%",
  ":focus-visible": {
    outline: 0,
    boxShadow: e.mode === R.Dye ? `inset 0 0 0 2px ${S.lightest}` : `inset 0 0 0 2px ${e.palette.primary.lightest}`
  },
  [`:not(.${B.disabled})`]: {
    cursor: "pointer",
    [`&.${B.selected}, :hover`]: {
      backgroundColor: e.mode === R.Dye ? S.lightest : e.palette.grey[100]
    }
  }
})), wt = j(function({ children: t, note: o, ...n }, s) {
  return /* @__PURE__ */ u.jsx(ct, { ref: s, type: "button", ...n, children: /* @__PURE__ */ u.jsx(it, { note: o, children: t }) });
}), dt = _("hr")(({ theme: e }) => {
  const { mode: t, palette: o, spacing: n } = e;
  return {
    "&:not(:first-child)": {
      border: 0,
      borderTop: t === R.Dye ? `1px solid ${S.main}` : `1px solid ${o.grey[400]}`,
      marginTop: n(1.25),
      marginBottom: n(2)
    }
  };
});
function ve(e) {
  e && (e.disabled = !0);
}
function he(e, t) {
  return /* @__PURE__ */ u.jsx(
    Z,
    {
      alignItems: "center",
      color: "gray.800",
      display: "flex",
      gap: 1,
      mb: 0.5,
      px: `var(${Q})`,
      ref: ie(t, ve),
      sx: ({ palette: o }) => ({ fill: o.gray[700] }),
      variant: "teenie",
      ...e
    }
  );
}
he.displayName = "SideTabGroupHeader";
const ut = j(he);
function Ut({ children: e, header: t }) {
  const { processChildren: o } = ge({ children: e, ref: null });
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(dt, {}),
    typeof t == "string" ? /* @__PURE__ */ u.jsx(ut, { children: t }) : t,
    o()
  ] });
}
const xe = j(function(t, o) {
  return /* @__PURE__ */ u.jsx(
    Z,
    {
      alignItems: "center",
      display: "flex",
      fontWeight: "semibold",
      gap: 1,
      mb: 3,
      ref: o,
      sx: ({ palette: n }) => ({ fill: n.primary.main }),
      variant: "biggie",
      ...t
    }
  );
}), ft = j(function(t, o) {
  return /* @__PURE__ */ u.jsx(xe, { px: `var(${Q})`, ref: ie(o, ve), ...t });
}), pt = _(Ze)(({ theme: e }) => ({
  borderRight: e.mode === R.Dye ? `1px solid ${S.main}` : `1px solid ${e.palette.primary.lightest}`,
  padding: `${e.spacing(2)} var(${K})`,
  flex: "225px 0 0",
  boxSizing: "border-box"
})), jt = j(function({ children: t, header: o, ...n }, s) {
  return /* @__PURE__ */ u.jsxs(pt, { ...n, ref: s, children: [
    typeof o == "string" ? /* @__PURE__ */ u.jsx(ft, { children: o }) : o,
    t
  ] });
}), bt = _(Ae)(({ theme: e, noPadding: t }) => ({
  flex: 1,
  ...t ? {} : {
    color: e.mode === R.Dye ? S.main : void 0,
    outline: e.mode === R.Dye ? `1px solid ${S.main}` : void 0,
    paddingTop: `var(${K})`,
    paddingRight: e.spacing(4),
    paddingBottom: `var(${K})`,
    paddingLeft: e.spacing(4)
  }
})), _t = j(function({ children: t, header: o, noPadding: n, ...s }, l) {
  return (
    // casting for performance
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /* @__PURE__ */ u.jsxs(bt, { ref: l, ...s, children: [
      typeof o == "string" ? /* @__PURE__ */ u.jsx(xe, { children: o }) : o,
      t
    ] })
  );
}), mt = j((e, t) => /* @__PURE__ */ u.jsx(Le, { orientation: "vertical", ref: t, ...e, "data-fabric-component": "SideTabs" })), Dt = _(mt)(({ theme: { mode: e, spacing: t } }) => ({
  display: "flex",
  outline: e === R.Dye ? `2px solid ${S.main}` : void 0,
  // Use CSS variables for style values shared by multiple components.
  [Q]: t(1.25),
  [K]: t(2.5)
  // Generics are lost with `styled`
  // https://mui.com/material-ui/guides/typescript#complications-with-the-component-prop
}));
export {
  wt as S,
  dt as a,
  Ut as b,
  ut as c,
  jt as d,
  ft as e,
  _t as f,
  xe as g,
  it as h,
  at as i,
  K as j,
  Dt as k,
  Q as s
};
//# sourceMappingURL=side-tabs-Z8LgYpws.mjs.map
